module.exports = __webpack_public_path__ + "static/media/The E Major.f883ab2e.png";